import { withViewModel } from '@hooks/useViewModel';
import CreateOrEditListDialog from './CreateOrEditListDialog';
import useEditListDialog from './useEditListDialog';

const EditListDialogContainer = withViewModel(CreateOrEditListDialog, useEditListDialog);

export default EditListDialogContainer;
